import React from "react";
import "../Profile/Profile.css";

const DAY_DISPLAY = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];

export default function CoffeeInviteModal({
  inviteeName,
  inviteeFullName,
  // optional date/time picker (mobile)
  days,
  availableTimesForDay,
  selectedDay,
  onSelectDay,
  selectedTime,
  onSelectTime,
  // message + phone
  message,
  onMessageChange,
  sharePhone,
  onSharePhoneChange,
  sending,
  sent,
  error,
  onSubmit,
  onClose,
}) {
  const showDatePicker = Array.isArray(days) && days.length > 0;
  const dayLabel = selectedDay
    ? selectedDay.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" })
    : null;

  return (
    <div className="pInviteOverlay" onClick={onClose}>
      <div className="pInviteModal" onClick={(e) => e.stopPropagation()}>
        <button className="pInviteClose" onClick={onClose}>✕</button>

        {sent ? (
          <div className="pInviteSent">
            <div className="pInviteSentIcon">☕</div>
            <h2 className="pInviteTitle">Invite sent!</h2>
            <p className="pInviteSubtitle">
              {inviteeName} will get an email and text with your invite.
            </p>
            <button className="pInviteCta" onClick={onClose}>Done</button>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <h2 className="pInviteTitle">Invite {inviteeName} to coffee ☕</h2>
            <p className="pInviteSubtitle">
              {dayLabel && (
                <><strong>{dayLabel}{selectedTime ? ` — ${selectedTime}` : ""}</strong><br /></>
              )}
              We'll send <strong>{inviteeFullName}</strong> an email and text on your behalf.
            </p>

            {showDatePicker && (
              <>
                <label className="pInviteLabel">Pick a day</label>
                <div className="inviteDaysRow" style={{ marginBottom: 12 }}>
                  {days.map((day, i) => {
                    const isActive = selectedDay && day.toDateString() === selectedDay.toDateString();
                    return (
                      <button
                        key={i}
                        type="button"
                        className={`inviteDayPill${isActive ? " inviteDayPill--active" : ""}`}
                        onClick={() => { onSelectDay(day); onSelectTime(null); }}
                      >
                        <span className="inviteDayName">{DAY_DISPLAY[day.getDay()]}</span>
                        <span className="inviteDayNum">{day.getDate()}</span>
                      </button>
                    );
                  })}
                </div>

                {selectedDay && Array.isArray(availableTimesForDay) && availableTimesForDay.length > 0 && (
                  <>
                    <label className="pInviteLabel">Pick a time</label>
                    <div className="inviteTimesRow" style={{ marginBottom: 12 }}>
                      {availableTimesForDay.map(t => (
                        <button
                          key={t}
                          type="button"
                          className={`inviteTimePill${selectedTime === t ? " inviteTimePill--active" : ""}`}
                          onClick={() => onSelectTime(t)}
                        >
                          {t}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </>
            )}

            <label className="pInviteLabel">Add a message (optional)</label>
            <textarea
              className="pInviteTextarea"
              placeholder={`Hey ${inviteeName}, I love  your work on urban photography and would love to hear how you approach storytelling through images over coffee. Would 9 AM @ Good Intentions Coffee work?`}
              value={message}
              onChange={(e) => onMessageChange(e.target.value)}
              rows={4}
              maxLength={300}
            />
            <p className="pInviteCharCount">{message.length}/300</p>

            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 10,
                margin: "0 0 16px",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={sharePhone}
                onChange={(e) => onSharePhoneChange(e.target.checked)}
                style={{
                  marginTop: 2,
                  width: 16,
                  height: 16,
                  flexShrink: 0,
                  accentColor: "#17154f",
                  cursor: "pointer",
                }}
              />
              <span style={{ fontSize: 13, lineHeight: 1.5, color: "rgba(0,0,0,0.7)" }}>
                I'm okay with sharing my phone number to coordinate finding a time and place to meet up
              </span>
            </label>

            {error && <p className="pInviteError">{error}</p>}

            <button
              className="pInviteCta"
              type="submit"
              disabled={sending || (showDatePicker && !selectedDay)}
            >
              {sending ? "Sending…" : "Send coffee invite"}
            </button>
            <p className="pInviteExpiry">☕ This invite expires after 24 hours.</p>
          </form>
        )}
      </div>
    </div>
  );
}
